import React from 'react';


export default () => {
  return (
    <div class="loaderdiv">
      <div class="loader" aria-hidden="true"></div>
    </div>);
};
